import React from 'react'
import {CircularProgress, CircularProgressProps, styled} from '@mui/material'
import circular_progressStyles from './circular_progress.styles'

interface ApCircularProgressProps extends CircularProgressProps {
  ap_type?: 'btn_spinner'
}

const apAtomName = {ap_atom_name: 'circularProgressAtom'}

const CircularProgressAtom = styled((props: ApCircularProgressProps) => (
  <CircularProgress {...props} {...apAtomName} />
))`
  ${circular_progressStyles}
`

export default CircularProgressAtom
